import { EnvironmentFilled, GlobalOutlined, PhoneFilled } from "@ant-design/icons";
import { Footer } from "antd/es/layout/layout";

const footer = () => {
    return (
      <Footer className="footer">
        <div className="footer-content">
        © BAGPS.TMS 2025
        </div>
      </Footer>
    )

}
export default footer;